import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';
interface IGetPostSaleChart {
  date_time: string;
  price: number;
}

export const getSaleChart = async (ctx: QueryFunctionContext) => {
  const {data}: {data: Array<IGetPostSaleChart>} = await request.get(
    `/api/v2/market/sale-chart?post_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
